import React, { useState } from "react";
import { Button } from "@my-scoot/component-library-legacy";
import { DisputeDocumentsLinksModal } from "./modules/DisputeDocumentLinksModal/DisputeDocumentLinksModal";

export const DisputeDocumentLinks = ({ record }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        color="link"
        size="small"
        className="!tw-bg-transparent !tw-text-[#493AB1] !tw-text-[16px] !tw-h-[10px] !tw-min-w-[10px] !tw-p-0"
        onClick={() => {
          setOpen(true);
        }}
      >
        View Links
      </Button>
      <DisputeDocumentsLinksModal
        open={open}
        setOpen={setOpen}
        record={record}
      />
    </>
  );
};
